<script lang="ts">
  import { ticker } from '../lib/ticker.svelte.ts';
  import { playSound } from '../lib/sounds.ts';

  /**
   * Yellow cards, small in the top-right corner: worth knowing, not worth
   * covering the picture for. Below the ticker and the auto-switch notice
   * when those are showing.
   */
  let { offsetEm = 0 }: { offsetEm?: number } = $props();

  /** A short whistle for each new yellow card. */
  let sounded = 0;
  $effect(() => {
    const newest = ticker.notes.at(-1);
    if (!newest || newest.id <= sounded) return;
    sounded = newest.id;
    playSound('whistleShort', ticker.style.sound);
  });
</script>

{#if ticker.notes.length > 0}
  <div class="notes" style:--offset={`${offsetEm}em`} role="status" aria-live="polite">
    {#each ticker.notes as note (note.id)}
      {@const f = note.fixture}
      {@const latest = f.extra?.incidents?.find((i) => i.id === note.incident.id) ?? note.incident}
      {@const player = latest.player}
      <div class="note">
        <span class="card" aria-label="Gelbe Karte"></span>
        {#if latest.photo}
          <img src={latest.photo} alt="" onerror={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }} />
        {/if}
        <span class="text">
          <span class="player">{player ?? 'Gelbe Karte'}</span>
          <span class="faint">{note.incident.side === 'home' ? f.homeTeam : f.awayTeam}{#if note.incident.minute} · {note.incident.minute}{/if}</span>
        </span>
      </div>
    {/each}
  </div>
{/if}

<style>
  .notes {
    position: absolute;
    top: calc(var(--safe-inset) + var(--offset));
    right: var(--safe-inset);
    z-index: 14;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.3em;
    max-width: 40%;
    pointer-events: none;
  }

  .note {
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding: 0.25em 0.7em;
    font-size: var(--font-sm);
    background: rgba(0, 0, 0, 0.72);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius);
    animation: life 7s ease-out both;
  }

  .card {
    flex-shrink: 0;
    width: 0.7em;
    height: 1em;
    border-radius: 0.12em;
    background: #f5c518;
  }

  img {
    flex-shrink: 0;
    width: 2.8em;
    height: 2.8em;
    object-position: top;
    border-radius: 50%;
    object-fit: cover;
  }

  /* Two lines, so the minute never cuts the name short. */
  .text { display: flex; flex-direction: column; min-width: 0; line-height: 1.25; }
  .player { font-weight: 600; overflow-wrap: anywhere; }

  /* Only opacity and transform, like the goal banner. */
  @keyframes life {
    0% { opacity: 0; transform: translateX(1em); }
    6% { opacity: 1; transform: none; }
    88% { opacity: 1; }
    100% { opacity: 0; }
  }
</style>
